module.exports = __webpack_public_path__ + "img/banner-cta-bg.a60b7f8.png";